import { useAuthContext } from '../hooks/useAuthContext';
import { usePaymentsContext } from '../hooks/usePaymentsContext';
import { isPaymentAdmin } from '../utils/admins';

import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import { tr } from 'date-fns/locale';

const PaymentDetails = ({ payment }) => {
	const { dispatch } = usePaymentsContext();
	const { user } = useAuthContext();

	const handleClick = async () => {
		if (!user) {
			return;
		}

		if (
			!window.confirm(
				`${payment.title} ödemesini silmek istediğinize emin misiniz?`
			)
		) {
			return;
		}

		const response = await fetch(`/api/payments/${payment._id}`, {
			method: 'DELETE',
			headers: {
				Authorization: `Bearer ${user.token}`,
			},
		});
		const json = await response.json();

		if (response.ok) {
			dispatch({ type: 'DELETE_PAYMENT', payload: json });
		}
	};

	const handleDownload = async () => {
		const response = await fetch(`/api/payments/download/${payment._id}`, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${user.token}`,
			},
		});

		if (!response.ok) {
			console.error('Download failed');
			return;
		}

		// Dosyayı Blob olarak al
		const blob = await response.blob();

		// Yeni bir indirme linki oluştur
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = `${payment.buyerName}.xlsx`; // Dosya adını belirle
		document.body.appendChild(a);
		a.click();

		// Belleği temizle
		window.URL.revokeObjectURL(url);
	};

	return (
		<div className="payment-details">
			<h4>{payment.title}</h4>
			<p>
				<strong>Müşteri Adı: </strong>
				{payment.buyerName}
			</p>
			<p>
				<strong>Müşteri Mail Adresi: </strong>
				{payment.buyerMail}
			</p>
			<p>
				<strong>Müşteri Adresi: </strong>
				{payment.buyerAddress}
			</p>
			<p>
				<strong>Müşteri Telefon Numarası: </strong>
				{payment.buyerPhone}
			</p>
			<p>
				<strong>Teklifi Oluşturan Hesap: </strong>
				{payment.creatorEmail || payment.user_id}
			</p>
			<p>
				{formatDistanceToNow(new Date(payment.createdAt), {
					addSuffix: true,
					locale: tr,
				})}
			</p>
			{isPaymentAdmin(user.email) ? (
				<span className="material-symbols-outlined" onClick={handleClick}>
					delete
				</span>
			) : (
				''
			)}
			<span
				class="material-symbols-outlined"
				id="download"
				onClick={handleDownload}
			>
				arrow_downward
			</span>
		</div>
	);
};

export default PaymentDetails;
